import { PriceDisplayWithTerm } from 'pricing-pages-ui-components/price/PriceDisplayWithTerm';
import SuiteProductLevelIdentifiersMap from 'pricing-pages-ui/constants/merchCards/SuiteProductLevelIdentifiersMap';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { useCrmSuitePricingInfo } from './useCrmSuitePricingInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export const CrmSuitePriceTermOverride = ({
  productLevel,
  termOverride,
  showPricePerMonthPerSeat,
  seleniumId
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  const {
    pricingInfo,
    loading
  } = useCrmSuitePricingInfo({
    termOverride,
    productLevel
  });
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [20],
    widths: ['100%'],
    children: pricingInfo && /*#__PURE__*/_jsx(PriceDisplayWithTerm, {
      pricingInfo: pricingInfo,
      seleniumId: seleniumId || SuiteProductLevelIdentifiersMap[productLevel],
      currencyCode: currencyCode,
      currencyCodeUnit: currencyCodeUnit,
      showPricePerMonthPerSeat: showPricePerMonthPerSeat
    })
  });
};
export default CrmSuitePriceTermOverride;